export default __webpack_public_path__ + "static/dd-mf-85691b403a3344f31842ef89e6efe486.jpg";